import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import "./Tabs.css";
const { TabPane } = Tabs;
const TabsOn = ({ size, tabNames, destroyInactiveTabPane = false, children }) => {
  const storedTab = localStorage.getItem("activeTab");
  const initialActiveTab = storedTab || tabNames[0].name;

  const [activeTab, setActiveTab] = useState(initialActiveTab);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <Tabs
      size={size}
      activeKey={activeTab}
      onChange={handleTabChange}
      className="my-tabs-tabs"
    >
      {tabNames.map((tab, index) => (
        <TabPane
          tab={
            <span className="tabs-icon">
              {tab.Icon} {tab.name}
            </span>
          }
          key={tab.name}
          destroyInactiveTabPane={destroyInactiveTabPane}
        >
          {React.Children.toArray(children)[index]}
        </TabPane>
      ))}
    </Tabs>
  );
};

export default TabsOn;
